/** Map an ISO-2 country code to a human label for use in multi-country
 *  dispatch UI. Consumed by every agent's result route (predicate +
 *  dossier + strategy today) so country names render identically across
 *  the app. Add new countries here, not in per-agent copies. */
export function countryLabel(code: string | null): string {
  if (!code) return 'Run';
  const upper = code.toUpperCase();
  const labels: Record<string, string> = {
    US: 'United States',
    EU: 'European Union',
    CA: 'Canada',
    UK: 'UK – Great Britain',
    NI: 'UK – Northern Ireland',
    JP: 'Japan',
    AU: 'Australia',
    KR: 'South Korea',
    TW: 'Taiwan',
  };
  return labels[upper] ?? upper;
}
